import React from "react";
import Modal from "react-bootstrap/Modal";
import IconButton from "../IconButton/IconButton";
import { Icons } from "../../../assets/icons";

const CustomModal = ({
  show = false,
  onClose,
  title = "Title",
  btnText = null,
  onSubmit,
  disabled,
  children,
  ...rest
}) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="custom-modal"
      {...rest}
    >
      {/* Header */}
      <Modal.Header className="position-relative">
        <p
          id="contained-modal-title-vcenter"
          className="moda-title label-content-600 teal-color m-0"
        >
          {title}
        </p>
        <IconButton
          icon={<Icons.CrossIcon />}
          width="10px"
          height="10px"
          handleClick={onClose}
          className="modal-close-btn"
        />
      </Modal.Header>

      {/* Body */}
      <div className="custom-modal-body">{children}</div>

      {/* Footer */}
      {btnText && (
        <div className="d-flex justify-content-center my-4">
          <button
            className="button-common button-fill"
            disabled={disabled}
            onClick={onSubmit}
          >
            {btnText}
          </button>
        </div>
      )}
    </Modal>
  );
};

export default CustomModal;
